import React, { Fragment, useContext, useState } from 'react';
import styles from "./header.module.scss";
import { NavItems,DistributorNavItems, seller } from './constant';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { Context as AuthContext } from '../../context/AuthContext';
import { TrackedLink } from '../Mixpanel/Tracked';

const SideNavbar = () => {
    let path = window.location.pathname;
    const [toggle,setToggle] = useState(false)
    const [toggleIndex,setToggleIndex] = useState(null)
    let header;

    const toggleListItem = (index) => {
        setToggleIndex(index);
        setToggle(!toggle);
    }
    const { state } = useContext(AuthContext);
    const role  = state && state.roleObj;
    const userData = state && state.userData;
    if(role.woSeller){
        header = NavItems;
    }
    else {
        header = DistributorNavItems;
    }
    if (userData?.seller_id === 24346) {
        header = seller;
    }
    return (
        <div className={styles.sideNav}>
            <div className="mt-1">
                {header.map((item, index) => {
                    return <div key={index}>{item.path ?
                        <TrackedLink name={item.name} to={item.path} className={`${path === item.path ? styles.active : null} ${styles.linkItem}`} onClick={() => { setToggle(null) }}>
                            <div key={index} className={styles.sideNavItem} >
                                <div className="d-flex justify-content-between" >
                                    {item.name}
                                </div>
                            </div>
                        </TrackedLink>
                        :
                        <Fragment>
                            <div className={`${styles.sideNavItem} d-flex align-items-center justify-content-between`} onClick={(e)=>{
                                e.stopPropagation();
                                toggleListItem(index)
                                }}>{item.name}
                            { !toggle ?
                                <KeyboardArrowDown/>
                                :
                                <KeyboardArrowUp/>
                            }
                            </div>
                        </Fragment>
                    }
                        {item.subItems && toggleIndex === index && toggle ?
                            <div id={styles.subItemsDiv}>
                                {item.subItems.map((sItems, sIndex) => {
                                    return <TrackedLink name={sItems.name} key={sIndex} to={sItems.path} className={`${path === sItems.path ? styles.sideNavactive : null} ${styles.menuLink}`}> {sItems.name} </TrackedLink>
                                })}
                            </div>
                            : null
                        }
                    </div>
                })}
            </div>
        </div>
    )
}

export default SideNavbar;
